import { SummerAppFieldTypesEnum } from 'app/shared/enums/field-types.enum';
import { QuestionBaseModel } from './question-base.model';
export class CheckboxQuestionModel extends QuestionBaseModel<boolean> {
    
        fieldTypeName = SummerAppFieldTypesEnum.Checkbox;

    
        constructor(options: {} = {}) {
          super(options);
          this.value=options['value']=="true";
        }
      }


// WEBPACK FOOTER //
// ./src/app/shared/models/checkbox-question.model.ts